import {ACTION_TYPES, GUID} from "../consts";
import {AnalyticsService} from "../../third-party-services/analytics/analytics-service";
import {AnalyticsEventHandler} from "../../infrastructure/handlers/analytics-event-handler";
import {BaseAnalyticsEvent} from "../../infrastructure/models/analytics/base-analytics-event";

export class GuidClickEventHandler extends AnalyticsEventHandler {
  type = ACTION_TYPES.guidClickEvent;
  guid: String;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.guid = null;
    this.ga4ClientId = null;
    this.ga4SessionId = null;
  }

  async action(params) {
    this.guid = this.generateGUID(GUID.LENGTH, GUID.CHARS);

    const sendParams = {
      guid: this.guid,
      ...params,
    }

    const event: BaseAnalyticsEvent = new this.eventType(sendParams);

    this.analyticsService.createEvent(event);
  }

  generateGUID(length, characters) {
    let result = '';

    for (let i = 0; i < length; i++) {
      const rand: Number = Math.random();
      const index: Number = Math.floor(rand * characters.length);
      result += characters.charAt(index);
    }

    return result;
  }
}
